<script setup>
// Components
import Button from '@/Components/Button/Button.vue';
import ImgMedia from '@/Components/Images/ImgMedia.vue';

import { register } from 'swiper/element/bundle';
import { ref } from 'vue';
register();

const props = defineProps({
    slides: Array,
});

const spaceBetween = ref(50);
</script>
<template>
    <swiper-container :loop="true" :slides-per-view="1" autoplay-delay="5000" autoplay-disable-on-interaction="true">
        <swiper-slide v-for="(item, i) in slides"
            class="relative min-h-[450px] xl:min-h-[500px] overflow-hidden bg-gray-light">
            <div v-if="item.image" class="absolute top-0 left-0 z-20 w-full h-full">
            </div>

            <ImgMedia v-if="item.image" :eager="i == 0" :media="item.image"
                :classes="'object-cover w-full h-[500px] xl:h-[550px] absolute top-0 left-0 z-10 '" />

            <div class="container relative z-30">
                <div class="flex items-center min-h-[500px] xl:min-h-[550px]">
                    <div class="lg:w-1/2">
                        <h1 :class="{ 'text-bodyColor': !item.image, 'text-white': item.image }" v-if="item.title">
                            {{ item.title }}
                        </h1>

                        <div v-if="item.text" v-html="item.text" class="prose"
                            :class="{ 'text-bodyColor': !item.image, 'text-white': item.image }"></div>

                        <Button v-if="item.button_label && item.intended_url" :label="item.button_label"
                            :href="item.intended_url" :external="!!item.external_url" class="relative z-30 w-auto mt-8" />
                    </div>
                </div>
            </div>
        </swiper-slide>
    </swiper-container>
</template>
